import React from 'react'


import{
  LoaderWrap,
  CommonLoader
} from "./LoaderStyle";  

const Loader = () => {
  return (
    <LoaderWrap>
      <CommonLoader className='common-loader'></CommonLoader>
   </LoaderWrap>
  )
}

export default Loader
 